export default "__VITE_PUBLIC_ASSET__d4b25f7e__"